import { orchestrator } from 'satcheljs';
import loadSmimeComposeInfobars from '../actions/loadSmimeComposeInfobars';
import SmimeErrorStateEnum from 'owa-smime-adapter/lib/store/schema/SmimeErrorStateEnum';
import addInfobarMessage from '../actions/addInfoBarMessage';

export default orchestrator(loadSmimeComposeInfobars, actionMessage => {
    const { viewState } = actionMessage;
    if (
        viewState.smimeViewState &&
        viewState.smimeViewState.errorCode != SmimeErrorStateEnum.NoError
    ) {
        const { errorCode } = viewState.smimeViewState;
        addInfobarMessage(
            viewState,
            errorCode == SmimeErrorStateEnum.ControlError
                ? 'smimeAdapterInitializationError'
                : 'smimeEncodeError'
        );
    }
});
